const theme = {
    colors: {
        buttonbg: "black",
        main: "white"
    },
    fontsizes: {
        
    },
    spacing: {
        
    },
    breakpoints: {
        tablet: '@media (max-width: 800px)',
        phone: '@media (max-width: 500px)'
    }
}

export default theme